import React from 'react';
import classNames from 'classnames';
import queryString from 'query-string';
import Modal from '#components/Layouts/Modal/Modal/Modal';
import AppVersion from '#components/Layouts/Site/AppVersion/AppVersion';
import { useJWTRefreshCheck } from '#modules/utils/jwt';
import styles from './ModalLayout.scss';

const ModalLayout = ({
  ModalComponent,
  fullscreen,
  allowBackgroundInteraction,
  onCloseModal,
  children,
  className,
  modalParameters,
  showAppVersion,
  nestedWidth,
  maxHeightModal,
  test,
}) => {
  useJWTRefreshCheck();

  return (
    <Modal
      show
      fullscreen={fullscreen}
      allowBackgroundInteraction={allowBackgroundInteraction}
      className={styles.modalLayout}
    >
      {!!fullscreen && <ModalComponent close={onCloseModal} />}
      {!fullscreen && (
        <Modal.Card
          className={classNames(
            styles.card,
            nestedWidth && styles.nested,
            className,
          )}
        >
          <div
            className={classNames(styles.modalCenter, styles.simpleDialog, {
              [styles.maxHeight]: maxHeightModal,
            })}
            data-test={test || `modal-${ModalComponent?.name}`}
            data-modal={test || `${ModalComponent?.name}`}
          >
            {children}
            {ModalComponent && (
              <ModalComponent
                onCloseModal={onCloseModal}
                {...queryString.parse(modalParameters)}
              />
            )}
          </div>
        </Modal.Card>
      )}
      {!!showAppVersion && <AppVersion />}
    </Modal>
  );
};

export default ModalLayout;
